import { ExternalLink } from "lucide-react";
import { OTHER_BOOKS } from "../mock/mock";
import useReveal from "../hooks/useReveal";

export default function OtherBooks() {
  const [ref, inView] = useReveal();

  return (
    <section id="autres-ouvrages" className="bg-white py-16 md:py-24">
      <div className="max-w-5xl mx-auto px-5 md:px-8">
        <h2 className="text-center font-heading text-3xl md:text-4xl font-extrabold text-[#5c2751]">
          Autres ouvrages
        </h2>
        <p className="mt-3 text-center text-[#6c6c6c]">
          Quelques lectures recommandées sur le Chemin.
        </p>
        <div
          ref={ref}
          className={`mt-12 grid sm:grid-cols-2 gap-8 ${inView ? "reveal in-view" : "reveal"}`}
        >
          {OTHER_BOOKS.map((b) => (
            <a
              key={b.title}
              href={b.link}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex gap-5 rounded-2xl bg-[#f7f4f6] p-5 transition-all hover:shadow-lg"
            >
              <img
                src={b.cover}
                alt={b.title}
                loading="lazy"
                decoding="async"
                className="h-36 w-auto rounded-md object-contain shadow"
              />
              <div className="flex flex-col justify-center">
                <h3 className="font-heading text-lg font-bold text-[#4a1f42]">
                  {b.title}
                </h3>
                <p className="mt-2 text-sm text-[#6c6c6c]">{b.detail}</p>
                <span className="mt-3 inline-flex items-center gap-1.5 text-sm font-semibold text-[#1b86f1]">
                  Voir sur la Fnac <ExternalLink className="h-3.5 w-3.5" />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
